var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96643 24.1734C4.35428 23.1001 2.66809 22.5634 2.50566 22.439C1.97969 22.0423 2.01063 22.4078 2.0261 15.2678L2.04931 8.82007L7.71119 10.4923L13.3808 12.1723V18.9623C13.3808 24.3367 13.3576 25.7445 13.288 25.7367C13.2338 25.7367 10.836 25.029 7.96643 24.1734Z",
    fill: "#D1D0D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6329 18.9621L14.6561 12.1721L20.3025 10.4999L25.9489 8.82764L25.9721 15.2676C25.9876 22.4076 26.0185 22.0343 25.4925 22.4387C25.3224 22.571 23.6903 23.0843 19.9854 24.181C17.0848 25.0443 14.6947 25.7443 14.6638 25.7443C14.6406 25.7443 14.6251 22.6876 14.6329 18.9621Z",
    fill: "#D1D0D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1373 10.15C9.66771 9.70663 7.24672 8.98329 5.74617 8.53996L3.03125 7.73107L8.39147 5.6933C11.3384 4.5733 13.8677 3.65552 13.9992 3.65552C14.2235 3.65552 25.0522 7.71552 24.9285 7.75441C24.8898 7.76218 22.4379 8.4933 19.4754 9.37218C16.5053 10.2511 14.0147 10.9666 13.9451 10.9589C13.8677 10.9511 12.6069 10.5855 11.1373 10.15Z",
    fill: "#D1D0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistory);
export default __webpack_public_path__ + "static/media/order-history.4c9a334d87a08863e3a047e77560ecc2.svg";
export { ForwardRef as ReactComponent };